import { Modal } from 'antd'
import { statusArray } from '../../../../shared/utils/appointmentHelpers'

export const eventStyleGetter = (event, darkCalendar) => {
  const status = statusArray.find(i => i.name === event.status)

  if (status) {
    return {
      style: {
        backgroundColor: darkCalendar ? status.dark : status.backgroundColor,
        borderColor: darkCalendar ? status.darkBorder : status.borderColor,
        color: darkCalendar ? '#f0f5ff' : status.colorHex,
        borderWidth: '5px 1px 1px 2px',
        borderRadius: 0
      }
    }
  } else {
    return {
      style: {
        color: '#2f54eb',
        backgroundColor: '#f0f5ff',
        borderColor: '#adc6ff',
        borderWidth: '5px 1px 1px 2px',
        borderRadius: 0
      }
    }
  }
}

export const showConfirm = t => {
  return new Promise(resolve => {
    Modal.info({
      title: t('calendar.smsWillBeSent'),
      content: t('calendar.confirmSendSms'),
      okText: t('common.yes'),
      cancelText: t('common.no'),
      okCancel: true,
      onOk() {
        resolve(true)
      },
      onCancel() {
        resolve(false)
      }
    })
  })
}

export const showCustomConfirm = (
  t,
  title,
  content = null,
  type = 'info',
  okText = 'common.confirm',
  cancelText = 'common.cancel'
) => {
  return new Promise(resolve => {
    Modal[type]({
      title,
      content,
      okText: t(okText),
      cancelText: t(cancelText),
      okCancel: true,
      okButtonProps: { danger: type === 'error' },
      onOk() {
        resolve(true)
      },
      onCancel() {
        resolve(false)
      }
    })
  })
}

export const confirmInvalidNumber = t =>
  new Promise((resolve, reject) =>
    Modal.confirm({
      title: t('common.phoneInvalid'),
      maskClosable: true,
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        reject(new Error('phoneInvalid'))
      },
      autoFocusButton: null,
      okText: t('common.confirm'),
      okButtonProps: { type: 'primary', danger: true }
    })
  )

export const confirmDuplicateAppointment = (t, title = 'app.duplicateAppointment') =>
  new Promise(resolve =>
    Modal.confirm({
      title: t(title),
      maskClosable: true,
      onOk: () => {
        resolve(true)
      },
      onCancel: () => {
        resolve(false)
      },
      autoFocusButton: null,
      okText: t('common.confirm'),
      okButtonProps: { type: 'primary', danger: true }
    })
  )
